import React from 'react';
import PropTypes from 'prop-types';

import MaterialCheckBox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { Field } from 'redux-form';

import { onClickWrapper } from '../../../utils/ui';

import Translation from '../Translation';

class Checkbox extends React.Component {
  static renderCheckbox = ({
    label,
    value,
    name,
    id,
    onClick,
    className,
    classNameChecked,
    classNameWrapper,
    input,
    translated,
    classNameTranslation,
    classNameLabel,
    icon,
    checkedIcon
  }) => {
    return label ? (
      <FormControlLabel
        control={
          <MaterialCheckBox
            checked={input ? !!input.value : value}
            value={name}
            id={id}
            onChange={onClickWrapper(id, input ? input.onChange : onClick)}
            className={className}
            classes={{
              checked: classNameChecked
            }}
            icon={icon}
            checkedIcon={checkedIcon}
          />
        }
        label={
          translated ? (
            <Translation
              keyIfNoValue
              id={id ? `${id}-label` : ''}
              className={classNameTranslation}
            >
              {label}
            </Translation>
          ) : (
            label
          )
        }
        classes={{
          root: classNameWrapper,
          label: classNameLabel
        }}
      />
    ) : (
      <MaterialCheckBox
        checked={input ? !!input.value : value}
        value={name}
        id={id}
        onChange={onClickWrapper(id, input ? input.onChange : onClick)}
        className={className}
      />
    );
  };

  render() {
    const {
      name,
      label,
      value,
      id,
      onClick,
      className,
      classNameChecked,
      classNameWrapper,
      validate,
      translated,
      classNameTranslation,
      classNameLabel,
      icon,
      checkedIcon
    } = this.props;

    const customProps = {
      label,
      value,
      id,
      onClick,
      className,
      classNameChecked,
      classNameWrapper,
      translated,
      classNameTranslation,
      classNameLabel,
      icon,
      checkedIcon
    };

    return name ? (
      <Field
        onChange={onClick}
        value={value}
        component={Checkbox.renderCheckbox}
        props={customProps}
        name={name}
        validate={validate}
      />
    ) : (
      Checkbox.renderCheckbox(customProps)
    );
  }
}

Checkbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.element,
  checkedIcon: PropTypes.element
};

export default Checkbox;
